import { useState, useEffect } from 'react';

/**
 * Debounce a value by the specified delay in milliseconds.
 * Useful for delaying search API calls until the user stops typing.
 */
export function useDebounce<T>(value: T, delay: number = 300): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedValue(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return debouncedValue;
}
